import s from '../collegesItem.module.css'
import {useEffect, useState} from "react";

import {Button, Select} from "antd";
import {useAddAlert} from "@/hooks/useAddAlert";
import {departments as departmentsApi} from "@api"


const ModalAddDepartments = ({userId, departments, setActive, update}) => {
  const addAlert = useAddAlert();
  const [loading, setLoading] = useState(false);

  const [unitsList, setUnitsList] = useState([]);
  const [isHead, setIsHead] = useState(null);

  const [unitId, setUnitId] = useState(null);
  
  useEffect(() => {
    departmentsApi.getAllIndex()
    .then(res => setUnitsList(res.data));
  }, []);
   
  const add = () => {
    let iam = false;
    
    departments.forEach(element => {
        if(element.id==unitId){
            iam = true;
        }
    })
    if(unitId){
        if(iam){
            addAlert({ text: 'Этот пользователь уже есть в этом отделе' });
        }
        else{
            setLoading(true)
            departmentsApi.addAnEmployeeToDepartment({
                userId: [userId],
                unitId: unitId,
                isHead: isHead
            })
            .then((res) => {
              if(res.data){
                addAlert({ text: 'Пользователь в отдел успешно добавлен' });
                update('departments')
                setActive(false);
              }
            })
            .finally((res)=>{
                setLoading(false)
            })
        }
    }
    else{
        addAlert({ text: 'Сперва выберите отдел' });
    }
  }
  
  return <div className="modal_departments">
    <h2 className="modal__title">Добавить отдел</h2>
    <div className={s.body}>
        <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Выберите отдел</span>
        <Select 
          className={s.input}
          style={{width: '100%'}} 
          onChange={(value) => setUnitId(value)} 
          placeholder='Выберите отдел'
          options={[...unitsList.filter(el=>el?.label!=='Ученики').map(el => ({ label: el?.label, value: el?.id }))]} 
        />

        <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Сделать руководителем отдела</span>
        <Select 
          className={s.input}
          style={{width: '100%'}} 
          onChange={(value) => setIsHead(value)} 
          placeholder='Сделать руководителем отдела'
          options={[{ label: 'Да', value: userId }, { label: 'Нет', value: null }]} 
        />
      <Button disabled={loading} onClick={add}>Сохранить</Button>
    </div>
  </div>
}
export default ModalAddDepartments